<template>
    <form class="line search-form">
      <div class="form-field">
        <input class="input-search tres" type="text"/>
      </div>
      <button class="btn btn-icon-search"></button>
    </form>
</template>

<script>
  export default {
    computed: {
    },
  };
</script>

<style lang="scss" scoped>
  .search-form {
    padding: 0px;
    display: flex;display: -ms-flexbox;
    flex-flow: row-reverse;
    align-items: center;
      @media (max-width: $media_md) {
          display: none;
      }
       .form-field {
       }
       .btn {
           margin-right: 5px;
           margin-top: 5px;
       }
       .input-search {
           padding: 6px 10px;
           border: none;
           border-radius: 8px;
           background: rgba($color-white,0.1);
           max-width: 140px;
           color: $color-white;
           &:hover,&:active,&:focus {
               box-shadow: 0px 0px 3px rgba($color-white,0.2);
               outline: none;
               border: none;
           }
       }

  }
</style>



// WEBPACK FOOTER //
// components/header/SearchForm.vue